<!--
 * @Author: 
 * @Date: 
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2021-11-23 17:29:02
 * @Description: file content
 -->
<template>
  <div class="bg">
    <!-- <div class="rank-info">
      <p>我的分数</p>
      <div class="count"><span>{{myRankNumber || 0}}</span>分</div>
    </div> -->
    <div class="podium-wrap">
      <!-- <div class="tips">Top100瓜分万元金喜</div> -->
      <div class="podium">
        <div class="rank1" v-if="rankList[0]"><img :src="rankList[0] && rankList[0].headImg" alt=""></div>
        <div class="rank2" v-if="rankList[1]"><img :src="rankList[1] && rankList[1].headImg" alt=""></div>
        <div class="rank3" v-if="rankList[2]"><img :src="rankList[2] && rankList[2].headImg" alt=""></div>
        <div class="rank1-info" v-if="rankList[0]">
          <div class="info-name">{{rankList[0].nickName}}</div>
          <div class="info-value">{{rankList[0].assistanceCount}}助力值</div>
        </div>
        <div class="rank2-info" v-if="rankList[1]">
          <div class="info-name">{{rankList[1].nickName}}</div>
          <div class="info-value">{{rankList[1].assistanceCount}}助力值</div>
        </div>
        <div class="rank3-info" v-if="rankList[2]">
          <div class="info-name">{{rankList[2].nickName}}</div>
          <div class="info-value">{{rankList[2].assistanceCount}}助力值</div>
        </div>
      </div>
      <!-- <div class="rank-title">{{area}}人气排行榜</div> -->
    </div>
    <div class="rank-list">
      <!-- <div class="rank-tab">
        <div class="rank-tab-item" :class="type==0?'self-tab-item':''" @click="upData(0)">
          个人排行
          <div class="line" v-show="type==0"></div>
        </div>
        <div class="rank-tab-item" :class="type==1?'self-tab-item':''" @click="upData(1)">
          战队排行
          <div class="line" v-show="type==1"></div>
        </div>
        <div class="rank-tab-item" :class="type==2?'self-tab-item':''" @click="upData(2)">
          我的战队
          <div class="line" v-show="type==2"></div>
        </div>
      </div> -->
      <template v-for="(item,index) in rankList">
        <div class="rank-item" v-if="index > 2" :key=index>
          <div class="rank-num" v-if="index>2">{{index+1}}</div>
          <!-- <div class="rank-num" v-else>
            <img :src="imgHost + 'rank'+(index+1)+'.png'" />
          </div> -->
          <img class="rank-img" :src="item.headImg" alt />
          <div class="rank-name">
            {{item.nickName}}
            <template v-if="item.num">（{{item.num}}人）</template>
          </div>
          <div class="rank-help-num">{{item.assistanceCount}}助力值</div>
        </div>
      </template>
      <div class="noDate" v-if="rankList.length==0">暂无数据</div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      rankList: [],
      team_list: [],
      pageNum: 1,
      pageTeamNum: 1,
      area: "",
      ranking: 0,
      score: 0,
      myTeam: [],
      type: 0,
      loading: false,
      isNoMore: true,
      isTeamNoMore: true,
      rank_item:{},
      myRankNumber: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async upData() {
      // let data
      // if (type == 0) {
      //   data = await this.$httpdf.get(this.apiHost + 'bird/rank')
        
      // } else if (type == 1) {
      //   data = await this.$httpdf.get(this.apiHost + 'bird/groupRank')
       
      // } else if (type == 2) {
      //   data = await this.$httpdf.get(this.apiHost + 'bird/myGroupRank')
      // }
      // if (data.code == 0) {
      //   this.rankList = data.data.ranks
      //   this.myRankNumber = data.data.myScore || data.data.myGroupScore
      // }
      // this.type = type;
      const data = await this.$httpdf.get(this.apiHost + 'assistance/totalList?limit=100')
      if (data.code == 0) {
        this.area = data.data.area
        this.rankList = data.data.list
      }
    },
  },
  created() {
    this.upData(); // 获取总排行榜
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.bg {
  background-color: #F3F3F3;
  .rank-info {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 20px 15px 0;
    p {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
    .count {
      margin-top: 20px;
      span {
        font-size: 30px;
      }
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 22px;
    }
  }
  .podium-wrap {
    position: relative;
    width: 100%;
    background: linear-gradient(135deg, #FF5F00, #FFA770);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0 26px;
    > .tips {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FEE481;
      line-height: 22px;
      text-align: center;
    }
    > .rank-title {
      position: absolute;
      top: 35px;
      right: 0;
      height: 28px;
      padding: 0 9px;
      border-radius: 14px 0 0 14px;
      box-sizing: border-box;
      background: linear-gradient(0deg, #FF5F00, #FFA770);
      border-radius: 14px 0px 0px 14px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      @extend .flex-center-center;
    }
    .podium {
      margin-top: 100px;
      width: 340px;
      height: 124px;
      background: url('https://assets.rurushishi.com/activies/common/podium.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      position: relative;
      img {
        width: 100%;
        height: auto;
        border-radius: 50%;
      }
      .info-name {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .info-value {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 10px;
      }
      .rank1 {
        width: 70px;
        height: 70px;
        position: absolute;
        bottom: 135px;
        left: 135px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 70px;
          border: 2px solid #FFE13D;
        }
        &::after{
          position: absolute;
          left: -3px;
          top: -15px;
          content: "";
          display: inline-block;
          width: 33px;
          height: 29px;
          background:  url('https://assets.rurushishi.com/activies/common/rank4.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        }
      }
      .rank1-info {
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        .info-name {
          width: 104px;
        }
      }
      .rank2 {
        width: 60px;
        height: 60px;
        position: absolute;
        bottom: 103px;
        left: 31px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 60px;
          border: 2px solid #E5E7F2;
        }
        &::after{
          position: absolute;
          left: -5px;
          top: -13px;
          content: "";
          display: inline-block;
          width: 30px;
          height: 27px;
          background:  url('https://assets.rurushishi.com/activies/common/rank5.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        }
      }
      .rank2-info {
        position: absolute;
        top: 58px;
        left: 30px;
        text-align: center;
        .info-name {
          width: 70px;
        }
      }
      .rank3 {
        width: 50px;
        height: 50px;
        position: absolute;
        bottom: 88px;
        right: 33px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 50px;
          border: 2px solid #FEB55B;
        }
        &::after{
          position: absolute;
          left: -1px;
          top: -12px;
          content: "";
          display: inline-block;
          width: 23px;
          height: 20px;
          background: url('https://assets.rurushishi.com/activies/common/rank6.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        }
      }
      .rank3-info {
        position: absolute;
        top: 71px;
        right: 30px;
        text-align: center;
        .info-name {
          width: 65px;
        }
      }
    }
  }
  
  .rank-tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EAEAEA;
    .rank-tab-item {
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      flex: 1;
      text-align: center;
      height: 43px;
      line-height: 41px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &.self-tab-item {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #3FA4FA;
      }
      .line {
        width: 33px;
        height: 2px;
        background:#3FA4FA;
        border-radius: 1px;
      }
    }
  }
  .rank-list {
    position: relative;
    width: 345px;
    margin-top: -26px;
    height: calc(100vh - 300px);
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    overflow-y: auto;
    z-index: 3;
    .rank-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 58px;
      line-height: 58px;
      margin: 0 7px;
      padding-right:8px;
      &+.rank-item {
        border-top: 1px solid #E1E1E1;
      }
      .rank-num {
        width: 20px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF4C1D;
        text-align: center;
        margin-right: 18px;
        img {
          width: 16px;
          height: 23px;
        }
      }
      .rank-img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
      .rank-name {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        flex: 1;
        padding: 0 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .rank-help-num {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        text-align: right;
      }
    }
    .noDate {
      text-align: center;
      padding: 8px 0;
      font-size: 14px;
    }
  }
}
</style>